export default __webpack_public_path__ + "static/media/black_19_melon_bronze_bloodshot_open_none.1663be7c.png";